/**
 * Multipart writes that the contract declares as PUT/PATCH.
 *
 * PHP parses a multipart body only on POST, so every contract that takes a
 * file on an update (marketing.yaml, merchants.yaml media) states the same
 * encoding: send `POST` and carry the declared verb in
 * `X-HTTP-Method-Override`. A client function still SAYS the declared verb —
 * that is the operation it implements — and this helper does the encoding.
 */

import type { ApiCall } from "./client";
import { METHOD_OVERRIDE_HEADER } from "./contracts/marketing";

export interface DeclaredMultipartCall {
  readonly method: "PUT" | "PATCH";
  readonly path: string;
  readonly body: FormData;
}

export function multipartOverride(call: DeclaredMultipartCall): ApiCall {
  return {
    method: "POST",
    path: call.path,
    body: call.body,
    headers: { [METHOD_OVERRIDE_HEADER]: call.method },
  };
}
